import React from "react";
import { FormikField } from "@qgiv/core-donor";

const PasswordConfirm = () => (
    <div className="grid">
        <div className="col col--12">
            <FormikField
                type="password"
                name="Password_Confirm"
                id="Password-Confirm"
                label="Confirm Password"
            />
        </div>
    </div>
);

export default PasswordConfirm;
